import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useAppContext } from './appProvider/contextProvider';
import HamburgerMenu from './components/HamburgerMenu/HamburgerMenu';
import Header from './components/Header/Header';
import SuspendedBar from './components/SuspendedBar/SuspendedBar';
import WrapperContainer from './components/WrapperContainer/WrapperContainer';

const Layout = () => {

    const history = useHistory();
    const { isMenuCollapsed,
        setMenuCollapsed, 
        setIsDirty, 
        setDiscardPromptOpen,
        setDiscardCallBack,
        setPathToNavigate,
        pathToNavigate,
        selectedWebsite,
    }= useAppContext();

    const onDiscard = () => {
        setDiscardPromptOpen(false);
        setIsDirty(false);
        if(pathToNavigate) {
            history.push(pathToNavigate);
        } else {
            document.dispatchEvent(new CustomEvent('discardEvent'));
        }     
        setDiscardCallBack(null);
        setPathToNavigate(null);
    }

    const onCancelDiscard = () => {
        setDiscardPromptOpen(false);
    }
    

    const [menuToggled, setMenuToggled] = useState(false);
    const [mainClass, setMainClass] = useState([]);

    useEffect(() => {
        const temp = [];
        if(menuToggled) {
            temp.push('open-nav');
        } else if(isMenuCollapsed) {
            temp.push('toggle-aside')
        }
        temp.push('full-height');
        setMainClass(temp);
    }, [menuToggled, isMenuCollapsed]);

    return <>
        {selectedWebsite?.is_suspended && <SuspendedBar />}
        <main className ={mainClass.join(' ')}>
            <div className="d-flex flex-column full-height">
                <div  className="d-flex align-items-start full-height">
                    <HamburgerMenu 
                        setMenuToggled={setMenuToggled} 
                        setMenuCollapsed={setMenuCollapsed} 
                        menuCollapsed = {isMenuCollapsed}
                        setPathToNavigate={setPathToNavigate}
                    />
                    <div className="d-flex flex-column full-width full-height">
                        <Header setMenuToggled={setMenuToggled}/>
                        <WrapperContainer
                            onCancelDiscard={onCancelDiscard}
                            onDiscard={onDiscard}
                        />
                    </div>
                </div>
            </div>
        </main>
    </>
}

export default Layout;